/**
 * This custom hook provides the functionality to retrieve users to be shown in the UI.
 */

import {useContext, useEffect, useState} from "react";
import {FirebaseAuthContext} from "../../../../commons/firebase/FirebaseAuthProvider";
import {useSnackbar} from "notistack";
import {useIntl} from "react-intl";

const useLoadSelectableScoredScenesInPlaylist = (playlistKey) => {

    const [scoredScenesSource, setScoredScenesSource] = useState([])
    const [loading, setLoading] = useState(true)

    const {signedInUser} = useContext(FirebaseAuthContext);
    const {enqueueSnackbar} = useSnackbar();

    // Internationalization for simple strings
    const intl = useIntl();

    // Retrieving the scored scenes, which are not yet included in the playlist
    const fetchSelectableScoredScenes = async () => {
        const idToken = await signedInUser.getIdToken()

        let selectableScoredScenesPromise
        if (playlistKey) {
            selectableScoredScenesPromise = fetch('/reg-main/playlists/' + playlistKey + '/unselectedScoredScenes?idToken=' + idToken)
        } else {
            selectableScoredScenesPromise = fetch('/reg-main/scoredScenes?idToken=' + idToken)
        }

        return selectableScoredScenesPromise
            .then(async (data) => {
                // Throw an error including the textual status of the HTTP response code (no detailed message necessary)
                if (data.status !== 200) {
                    throw new Error((await data.json()).status)
                }

                const scoredScenesJson = await data.json();
                setScoredScenesSource(scoredScenesJson)
            })
            .catch((error) => {
                enqueueSnackbar(
                    intl.formatMessage({
                        id: 'app.playlists.messages.load.selectableScoredScenes.error',
                        defaultMessage: 'Something went wrong while loading the selectable video scenes of the playlist: {error}'
                    }, {error: error.message}), {
                        variant: 'error',
                        preventDuplicate: true,
                        autoHideDuration: 5000
                    });
            })
    }

    useEffect(() => {
        // Wait until all lists are fetched before removing the loading indication
        fetchSelectableScoredScenes()
            .finally(() => {
                setLoading(false)
            })

    }, [])


    return {
        loading,
        scoredScenesSource,
        setScoredScenesSource
    }
}
export default useLoadSelectableScoredScenesInPlaylist;